import { createContext, useContext } from 'react';

import type { EDealType, EOfferType } from 'shared/types/features';

export interface IGuideAnalytics {
  trackPageCategory: (nextDealType?: EDealType | null, nextOfferType?: EOfferType | null) => void;
  trackArticleClick: (articleName: string, articleLink: string, categoryName?: string) => void;
  trackFaqLinkClick: (questionId: number, question: string, link: string) => void;
  trackFaqQuestionOpen: (questionId: number, question: string) => void;
  trackPlaceAdClick: (bannerName: string) => void;
  trackHowItsWorkClick: () => void;
  trackSocialClick: (social: string) => void;
}

export const NOOP_GUIDE_ANALYTICS: IGuideAnalytics = {
  trackPageCategory: (): void => {},
  trackArticleClick: (): void => {},
  trackFaqLinkClick: (): void => {},
  trackFaqQuestionOpen: (): void => {},
  trackPlaceAdClick: (): void => {},
  trackHowItsWorkClick: (): void => {},
  trackSocialClick: (): void => {},
};

export const GuideAnalyticsContext = createContext<IGuideAnalytics>(NOOP_GUIDE_ANALYTICS);

export const useGuideAnalytics = (): IGuideAnalytics => useContext(GuideAnalyticsContext);
